// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarEventForm_shadow{
    z-index: 1000;
}

.CalendarEventForm_wrapper{

}

.CalendarEventForm_form{
    display: flex;
    flex-wrap: wrap;
    gap: 0px 22px;
}

.CalendarEventForm_header{
    display: flex;
    gap: 10px;
    justify-content: space-between;
}

.CalendarEventForm_buttons{
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    height: 100%;
    gap: 10px;  
}

.CalendarEventForm_formItem{
    margin: 10px 0px;
}

.CalendarEventFormItem--line{
    width: 100%;
}

.CalendarEventForm_formItem_label{
    font-size: calc(13px * var(--fontScaler));
    margin-bottom: 5px;
}

.CalendarEventForm_textInput{
    display: block;
    resize: none;
    height: 100%;
    width: 100%;
    border-radius: 10px;
    border: 1px #ccc solid;
    padding: 10px;
    font-size: calc(13px * var(--fontScaler));
    min-height: 100px;
}

.CalendarEventForm_textInput:focus{
    outline: none;
    border: 1px #FFA825 solid;
}

.CalendarEventForm_sessions{
    display: flex;
    flex-direction: column;
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/calendarGrid/CalendarEventForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,sBAAsB;IACtB,aAAa;IACb,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB","sourcesContent":[".CalendarEventForm_shadow{\n    z-index: 1000;\n}\n\n.CalendarEventForm_wrapper{\n\n}\n\n.CalendarEventForm_form{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0px 22px;\n}\n\n.CalendarEventForm_header{\n    display: flex;\n    gap: 10px;\n    justify-content: space-between;\n}\n\n.CalendarEventForm_buttons{\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n    height: 100%;\n    gap: 10px;  \n}\n\n.CalendarEventForm_formItem{\n    margin: 10px 0px;\n}\n\n.CalendarEventFormItem--line{\n    width: 100%;\n}\n\n.CalendarEventForm_formItem_label{\n    font-size: calc(13px * var(--fontScaler));\n    margin-bottom: 5px;\n}\n\n.CalendarEventForm_textInput{\n    display: block;\n    resize: none;\n    height: 100%;\n    width: 100%;\n    border-radius: 10px;\n    border: 1px #ccc solid;\n    padding: 10px;\n    font-size: calc(13px * var(--fontScaler));\n    min-height: 100px;\n}\n\n.CalendarEventForm_textInput:focus{\n    outline: none;\n    border: 1px #FFA825 solid;\n}\n\n.CalendarEventForm_sessions{\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
